let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e2VF1")).then(() => parcelRequire('lyW48'));